<div class="dashboard">

    <div class="row">

        <div class="col-12" *ngIf="summary || loading">
            <div class="dash-card">
                <div class="dash-card-body p-4">
                    <div class="dash-card-statistics">

                        <ng-container *ngIf="loading">
                            <div class="col-12 p-0">
                                <div class="row w-100 m-0">
                                    <div class="pl-0 pr-2 col-2">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '89px',
                                            width: '100%',
                                            margin:'0'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>

                                    <div class="px-2 col-2">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '89px',
                                            width: '100%',
                                            margin:'0'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>

                                    <div class="px-2 col-2">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '89px',
                                            width: '100%',
                                            margin:'0'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>

                                    <div class="px-2 col-2">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '89px',
                                            width: '100%',
                                            margin:'0'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>

                                    <div class="pr-0 pl-2 col-2">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '89px',
                                            width: '100%',
                                            margin:'0'
                                        }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                        <ng-container *ngIf="!loading && summary">
                            <div class="dash-card-statistics-item">
                                <span class="dash-card-statistics-title">Em
                                    aprovação</span>
                                <app-spacer [bottom]="4"></app-spacer>
                                <span class="dash-card-statistics-value">{{
                                    summary.total_in_approval }}</span>
                            </div>

                            <div class="dash-card-statistics-item">
                                <span
                                    class="dash-card-statistics-title">Aprovados</span>
                                <app-spacer [bottom]="4"></app-spacer>
                                <span class="dash-card-statistics-value">{{
                                    summary.total_homologated }}</span>
                            </div>

                            <div class="dash-card-statistics-item">
                                <span
                                    class="dash-card-statistics-title">Integrados</span>
                                <app-spacer [bottom]="4"></app-spacer>
                                <span class="dash-card-statistics-value">{{
                                    summary.total_integrated }}</span>
                            </div>

                            <div class="dash-card-statistics-item">
                                <span class="dash-card-statistics-title">Não
                                    integrados</span>
                                <app-spacer [bottom]="4"></app-spacer>
                                <span class="dash-card-statistics-value">{{
                                    summary.total_not_integrated }}</span>
                            </div>

                            <div class="dash-card-statistics-item">
                                <span class="dash-card-statistics-title">Total
                                    de fundos</span>
                                <app-spacer [bottom]="4"></app-spacer>
                                <span class="dash-card-statistics-value">{{
                                    summary.total_funds }}</span>
                            </div>
                        </ng-container>

                    </div>
                </div>
            </div>
            <app-spacer [bottom]="24"></app-spacer>
        </div>

        <div class="col-12">

            <div class="dash-card">

                <div class="row no-gutters">
                    <div class="col-12">
                        <span>Fundos</span>
                    </div>

                    <div class="col-12 padding-container dash-card-body">
                        <div clsas="styled-scroll">
                            <table class="bordered">
                                <thead>
                                    <tr>
                                        <th>Fundo</th>
                                        <th></th>
                                        <th></th>
                                        <th></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr *ngFor="let fund of funds">
                                        <td>
                                            <div class="dash-card-item">
                                                <div
                                                    class="dash-card-item-initials">
                                                    <span>{{getFundInitials(fund)}}</span>
                                                </div>

                                                <app-spacer
                                                    [right]="16"></app-spacer>

                                                <div
                                                    class="dash-card-item-content">
                                                    <div
                                                        class="dash-card-item-content-title">
                                                        {{fund.name}}
                                                    </div>
                                                    <div
                                                        class="dash-card-item-content-subtitle">
                                                        {{fund.slug}}
                                                    </div>
                                                </div>

                                            </div>
                                        </td>
                                        <td>
                                            <!-- {{fund.initial_quota | currency}} -->
                                        </td>
                                        <td>
                                            <!-- {{fund.min_redemption | currency}} -->
                                        </td>
                                        <td style="text-align: right;">
                                            <a
                                                [routerLink]="['/app/dashboard/approval/', fund.id]">
                                                <button class="button">
                                                    <svg-icon
                                                        src="assets/images/icon-eye.svg"></svg-icon>
                                                </button>
                                            </a>
                                        </td>

                                    </tr>

                                    <tr *ngIf="funds.length === 0">
                                        <td colspan="3">
                                            <span
                                                class="dash-card-item-content-subtitle">Nenhum
                                                fundo
                                                adicionado</span>
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            <div *ngIf="funds.length === 0">
                                <app-spacer [bottom]="30"></app-spacer>
                            </div>
                        </div>
                        <app-spacer [bottom]="2"></app-spacer>
                    </div>
                </div>
            </div>

            <div class="dash-card-pagination">
                <app-pagination [dashPagination]="true" [data]=" funds">
                </app-pagination>
            </div>

        </div>
    </div>
</div>